export default {
  'easyRecord.page.dashboard': 'EasyRecord Workspace',
  'easyRecord.page.threads': 'Topic Management',
  'easyRecord.page.records': 'Record Management',
  'easyRecord.page.search': 'Search & Recall',
  'easyRecord.page.settings': 'Settings',
  'easyRecord.page.tags': 'Tag Management',

  'easyRecord.dashboard.kicker': 'Content Overview',
  'easyRecord.dashboard.description':
    "Track recent topics, today's records, and fresh activity at a glance",
  'easyRecord.dashboard.workspaceTitle': 'Record Workspace',
  'easyRecord.dashboard.workspaceDescription':
    "Review today's captures, recent knowledge buildup, and topic organization progress so you can decide what to capture, classify, or revisit next.",
  'easyRecord.dashboard.summary.today': "Today's Captures",
  'easyRecord.dashboard.summary.todayDesc': 'New records today',
  'easyRecord.dashboard.summary.week': 'Last 7 Days',
  'easyRecord.dashboard.summary.weekDesc': '{count} per day',
  'easyRecord.dashboard.summary.activeThreads': 'Active Topics',
  'easyRecord.dashboard.summary.activeThreadsDesc':
    'Topics with recent records',
  'easyRecord.dashboard.focusThreads': 'Topics To Continue',
  'easyRecord.dashboard.contentStructure': 'Content Structure',
  'easyRecord.dashboard.latestCaptures': 'Latest Captures',
  'easyRecord.dashboard.scopeLabel': 'Current scope',
  'easyRecord.dashboard.scopeAll': 'All accessible records',
  'easyRecord.dashboard.scopeSource': 'Current business source',
  'easyRecord.dashboard.organizeQueue': 'Organization Queue',
  'easyRecord.dashboard.queue.inbox': 'Not in a topic',
  'easyRecord.dashboard.queue.untagged': 'No tags',
  'easyRecord.dashboard.queue.important': 'Important records',
  'easyRecord.dashboard.queue.activeThreads': 'Active topics',
  'easyRecord.dashboard.queue.inboxHint':
    'Place records in the right topic to preserve context',
  'easyRecord.dashboard.queue.untaggedHint':
    'Add tags to improve search and recall',
  'easyRecord.dashboard.queue.importantHint':
    'Review key content and confirm next actions',
  'easyRecord.dashboard.organizeQueueDesc':
    'Prioritize content without topics, tags, or enough review context.',
  'easyRecord.dashboard.latestCapturesDesc':
    'Fresh captures entering EasyRecord, ready for context and reuse.',
  'easyRecord.dashboard.focusThreadsDesc':
    'Topics that are still accumulating useful records.',
  'easyRecord.dashboard.contentStructureDesc':
    'Understand the composition of current record assets.',
  'easyRecord.dashboard.assetHealth': 'Organization Coverage',
  'easyRecord.dashboard.noTags': 'No tags yet',
  'easyRecord.dashboard.noPreview': 'No preview available',
  'easyRecord.dashboard.pulse.today': 'Today',
  'easyRecord.dashboard.pulse.week': 'Last 7 days',
  'easyRecord.dashboard.pulse.average': 'Daily average',
  'easyRecord.dashboard.todayTitle': "Today's record workspace",
  'easyRecord.dashboard.todaySummary':
    'You added {today} records today and {week} records in the last 7 days. Triage new captures, then return to key topics.',
  'easyRecord.dashboard.focusHeadline':
    '{today} new records today, {queue} items to organize',
  'easyRecord.dashboard.focusPendingDescription':
    'Classify and tag new content first, then continue with recent topics.',
  'easyRecord.dashboard.focusClearDescription':
    'Your organization queue is clear. You can keep capturing new content.',
  'easyRecord.dashboard.action.organize': 'Start Organizing',
  'easyRecord.dashboard.action.manageTopics': 'Manage Topics',
  'easyRecord.dashboard.todayCapture': "Today's Captures",
  'easyRecord.dashboard.weekTotal': '{count} in 7 days',
  'easyRecord.dashboard.recentActivity': 'Recent Activity',
  'easyRecord.dashboard.latestActivityAt': 'Updated {time}',
  'easyRecord.dashboard.noActivity': 'No updates yet',
  'easyRecord.dashboard.insightTitle': 'Record Type Distribution',
  'easyRecord.dashboard.insightDescription':
    'See which kinds of records are shaping the latest activity in EasyRecord.',
  'easyRecord.dashboard.insightLeading':
    '{type} leads the mix at about {percent}% of all records.',
  'easyRecord.dashboard.lastUpdated': 'Last updated',
  'easyRecord.dashboard.coverageDescription':
    'The share of all records that have been placed in a topic.',
  'easyRecord.dashboard.organizedRecords': '{count} records in topics',
  'easyRecord.dashboard.metric.totalThreadsHint': 'Current total topics',
  'easyRecord.dashboard.metric.totalRecordsHint': 'Current total records',
  'easyRecord.dashboard.metric.todayRecordsHint': 'Based on local date',
  'easyRecord.dashboard.metric.weekRecordsHint': 'New in the last 7 days',
  'easyRecord.dashboard.metric.toOrganize': 'To Organize',
  'easyRecord.dashboard.metric.toOrganizeHint':
    'Items needing topics, tags, or review',
  'easyRecord.dashboard.metric.dailyAverageTitle': 'Daily Average',
  'easyRecord.dashboard.metric.dailyAverageHint':
    'Average new records in 7 days',
  'easyRecord.dashboard.metric.activeTopics': 'Active topics',
  'easyRecord.dashboard.metric.typeKinds': '{count} record types',
  'easyRecord.dashboard.metric.todayVsWeek': '{count} this week',
  'easyRecord.dashboard.metric.dailyAverage': '{count} per day',
  'easyRecord.dashboard.memberCount': '{count} members',
  'easyRecord.dashboard.rhythmTitle': 'Content Rhythm',
  'easyRecord.dashboard.rhythmDailyAverage': 'Avg. records in 7 days',
  'easyRecord.dashboard.rhythmToday': 'Today',
  'easyRecord.dashboard.rhythmRecent': 'Recent',
  'easyRecord.dashboard.rhythmLastUpdated': 'Last updated',
  'easyRecord.threads.description':
    'Manage topics and archive status in EasyRecord',
  'easyRecord.records.description':
    'Browse, filter, and manage records in EasyRecord',
  'easyRecord.search.description':
    'Search records by keywords and quickly recall content',
  'easyRecord.settings.description':
    'Configure basic preferences for EasyRecord',

  'easyRecord.action.addThread': 'Add Topic',
  'easyRecord.action.editThread': 'Edit Topic',
  'easyRecord.action.addRecord': 'Add Record',
  'easyRecord.action.backToList': 'Back to List',
  'easyRecord.action.archive': 'Archive',
  'easyRecord.action.unarchive': 'Unarchive',
  'easyRecord.action.pin': 'Pin',
  'easyRecord.action.unpin': 'Unpin',
  'easyRecord.action.view': 'View',
  'easyRecord.action.edit': 'Edit',
  'easyRecord.action.delete': 'Delete',
  'easyRecord.action.save': 'Save',
  'easyRecord.action.reset': 'Reset',
  'easyRecord.action.search': 'Search',
  'easyRecord.action.refresh': 'Refresh',
  'easyRecord.action.confirm': 'Confirm',
  'easyRecord.action.cancel': 'Cancel',
  'easyRecord.action.complete': 'Complete',

  'easyRecord.common.actions': 'Actions',
  'easyRecord.common.loading': 'Loading...',
  'easyRecord.common.noData': 'No data',
  'easyRecord.common.noRecords': 'No records',
  'easyRecord.common.total': 'Total {count} items',

  'easyRecord.confirm.deleteThread':
    'Are you sure you want to delete this topic?',
  'easyRecord.confirm.deleteContent': 'Delete records under this topic as well',
  'easyRecord.confirm.deleteContentDesc':
    'If checked, the topic and all related records will be deleted and cannot be recovered.',

  'easyRecord.message.loadFailed': 'Failed to load. Please try again later.',
  'easyRecord.message.saveFailed': 'Failed to save. Please try again later.',
  'easyRecord.message.saveSuccess': 'Saved successfully',
  'easyRecord.message.createSuccess': 'Created successfully',
  'easyRecord.message.updateSuccess': 'Updated successfully',
  'easyRecord.message.deleteSuccess': 'Deleted successfully',
  'easyRecord.message.deleteFailed':
    'Failed to delete. Please try again later.',
  'easyRecord.message.pinSuccess': 'Pinned successfully',
  'easyRecord.message.unpinSuccess': 'Unpinned successfully',
  'easyRecord.message.archiveSuccess': 'Archived successfully',
  'easyRecord.message.unarchiveSuccess': 'Unarchived successfully',

  'easyRecord.stats.totalThreads': 'Total Topics',
  'easyRecord.stats.totalRecords': 'Total Records',
  'easyRecord.stats.todayRecords': "Today's Records",
  'easyRecord.stats.weekRecords': 'Last 7 Days',

  'easyRecord.recent.threads': 'Recent Topics',
  'easyRecord.recent.activity': 'Recent Activity',

  'easyRecord.thread.title': 'Topic Title',
  'easyRecord.thread.description': 'Description',
  'easyRecord.thread.recordDate': 'Record Date',
  'easyRecord.thread.lunarDate': 'Lunar Date',
  'easyRecord.thread.province': 'Province',
  'easyRecord.thread.city': 'City',
  'easyRecord.thread.district': 'District',
  'easyRecord.thread.detailedLocation': 'Detailed Location',
  'easyRecord.thread.location': 'Location',
  'easyRecord.thread.weather': 'Weather',
  'easyRecord.thread.coverImageUrl': 'Cover Image URL',
  'easyRecord.thread.tags': 'Tags',
  'easyRecord.thread.notes': 'Notes',
  'easyRecord.thread.recordCount': 'Record Count',
  'easyRecord.thread.isPinned': 'Pinned',

  'easyRecord.form.required': 'This field is required',
  'easyRecord.form.placeholder.title': 'Enter topic title',
  'easyRecord.form.placeholder.description': 'Enter description',
  'easyRecord.form.placeholder.recordDate': 'Select record date',
  'easyRecord.form.placeholder.lunarDate': 'Enter lunar date',
  'easyRecord.form.placeholder.province': 'Enter province',
  'easyRecord.form.placeholder.city': 'Enter city',
  'easyRecord.form.placeholder.district': 'Enter district',
  'easyRecord.form.placeholder.detailedLocation': 'Enter detailed location',
  'easyRecord.form.placeholder.weather': 'Enter weather',
  'easyRecord.form.placeholder.coverImageUrl': 'Enter cover image URL',
  'easyRecord.form.placeholder.tags': 'Enter tags (press Enter to confirm)',
  'easyRecord.form.placeholder.notes': 'Enter notes',

  'easyRecord.record.untitled': 'Untitled Record',
  'easyRecord.record.recordType': 'Record Type',
  'easyRecord.record.content': 'Content',
  'easyRecord.record.summary': 'Summary',
  'easyRecord.record.createdAt': 'Created At',
  'easyRecord.record.updateTime': 'Updated At',
  'easyRecord.record.aiModel': 'AI Model',
  'easyRecord.record.creator': 'Creator',
  'easyRecord.record.isImportant': 'Important',
  'easyRecord.record.notImportant': 'Normal',

  'easyRecord.task.title': 'Task Title',
  'easyRecord.task.status': 'Status',
  'easyRecord.task.priority': 'Priority',
  'easyRecord.task.progress': 'Progress',
  'easyRecord.task.dueDate': 'Due Date',

  'easyRecord.search.placeholder': 'Enter keyword',
  'easyRecord.search.noResults': 'No results found',
  'easyRecord.search.recordType': 'Record Type',
  'easyRecord.search.importance': 'Importance',
  'easyRecord.search.status': 'Task Status',
  'easyRecord.search.priority': 'Priority',
  'easyRecord.search.dateRange': 'Date Range',

  'easyRecord.settings.general': 'General Settings',
  'easyRecord.settings.enableNotifications': 'Enable Notifications',
  'easyRecord.settings.autoSave': 'Auto Save',

  'easyRecord.device.search.keyword': 'Keyword',
  'easyRecord.device.search.keywordPlaceholder':
    'Device name / model / alias / serial number',
  'easyRecord.device.search.vendor': 'Vendor',
  'easyRecord.device.search.vendorPlaceholder': 'Select vendor',
  'easyRecord.device.search.status': 'Binding Status',
  'easyRecord.device.search.statusPlaceholder': 'Select status',

  'easyRecord.device.table.deviceName': 'Device Name',
  'easyRecord.device.table.vendor': 'Vendor',
  'easyRecord.device.table.category': 'Category',
  'easyRecord.device.table.status': 'Status',
  'easyRecord.device.table.alias': 'Alias',
  'easyRecord.device.table.serialNumber': 'Serial Number',
  'easyRecord.device.table.boundAt': 'Bound At',
  'easyRecord.device.table.updatedAt': 'Updated At',

  'easyRecord.device.status.bound': 'Bound',
  'easyRecord.device.status.unbound': 'Unbound',

  'easyRecord.device.view.all': 'All',
  'easyRecord.device.view.bound': 'Bound',
  'easyRecord.device.view.unbound': 'Unbound',

  'easyRecord.device.action.bind': 'Bind Device',
  'easyRecord.device.action.rebind': 'Rebind',
  'easyRecord.device.action.unbind': 'Unbind',

  'easyRecord.device.message.bindSuccess': 'Device bound successfully',
  'easyRecord.device.message.unbindSuccess': 'Device unbound successfully',

  'easyRecord.device.futureHint': 'Device integration placeholder',
  'easyRecord.device.futureHintDesc':
    'This is a front-end management placeholder. Future versions can integrate authentication, binding, status sync, and audio import for Plaud, DingTalk One, Mobvoi, and similar recorder cards.',

  'easyRecord.device.density.large': 'Comfortable',
  'easyRecord.device.density.middle': 'Default',
  'easyRecord.device.density.small': 'Compact',

  'easyRecord.device.modal.bindTitle': 'Bind Device',
  'easyRecord.device.modal.devicePlaceholder': 'Select a device',
  'easyRecord.device.modal.aliasPlaceholder':
    'Enter device alias (e.g. Meeting Room Recorder)',
  'easyRecord.device.modal.serialPlaceholder': 'Enter serial number',

  'easyRecord.priority': 'Priority',
  'easyRecord.priority.urgent': 'Urgent',
  'easyRecord.priority.high': 'High',
  'easyRecord.priority.medium': 'Medium',
  'easyRecord.priority.low': 'Low',

  'easyRecord.status': 'Status',
  'easyRecord.status.todo': 'To Do',
  'easyRecord.status.pending': 'Pending',
  'easyRecord.status.in_progress': 'In Progress',
  'easyRecord.status.completed': 'Completed',
  'easyRecord.status.cancelled': 'Cancelled',
};
